export default function initSearch() {
    
    const searchTrigger = document.getElementById('desktop-search-trigger');
    const searchForm = document.getElementById('search-form');
    const searchInput = document.getElementById('search-input');
    const clearButton = document.getElementById('clear-search');
    const searchResultsContainer = document.getElementById('search-results');

    // Toggle search form visibility
    if (searchTrigger && searchForm) {
        searchTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            searchForm.classList.toggle('hidden');
            
            // Focus on input when opening
            if (!searchForm.classList.contains('hidden')) {
                searchInput?.focus();
            }
        });
    }

    // Clear search functionality
    if (clearButton && searchInput) {
        // Initially hide the clear button
        clearButton.style.display = 'none';
        
        clearButton.addEventListener('click', (e) => {
            e.preventDefault();
            searchInput.value = '';
            searchInput.focus();
            hideSpinner();
            clearSearchResults();
            clearButton.style.display = 'none'; // Hide clear button after clearing
        });
    }

    // Close search when clicking outside
    document.addEventListener('click', (e) => {
        if (searchForm && !searchForm.contains(e.target) && !searchTrigger.contains(e.target)) {
            searchForm.classList.add('hidden');
            hideSpinner();
        }
    });

    // Handle search input with debouncing
    let searchTimeout;
    if (searchInput) {
        searchInput.addEventListener('input', (e) => {
            clearTimeout(searchTimeout);
            const query = e.target.value.trim();

            // Show/hide clear button based on input content
            if (clearButton) {
                clearButton.style.display = query.length > 0 ? 'flex' : 'none';
            }

            if (query.length >= 3) {
                showSpinner();
                searchTimeout = setTimeout(() => {
                    performSearch(query);
                }, 300); // 300ms debounce
            } else {
                hideSpinner();
                clearSearchResults();
            }
        });

        // Handle Enter key
        searchInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                const query = searchInput.value.trim();
                if (query.length > 0) {
                    window.location.href = `/?s=${encodeURIComponent(query)}`;
                }
            }
        });
    }

    // Handle form submission
    if (searchForm) {
        searchForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const query = searchInput.value.trim();
            if (query.length > 0) {
                window.location.href = `/?s=${encodeURIComponent(query)}`;
            }
        });
    }

    // Show spinner function
    function showSpinner() {
        hideSpinner();
        
        if (searchForm) {
            const spinner = document.createElement('img');
            spinner.id = 'search-spinner';
            spinner.className = 'absolute right-28';
            spinner.src = 'https://happenings.pl/wp-content/uploads/2025/06/search-spinner.gif';
            spinner.width = 60;
            spinner.height = 60;
            spinner.alt = 'Search Spinner';
            spinner.loading = 'lazy';
            
            searchForm.appendChild(spinner);
        }
    }

    // Hide spinner function
    function hideSpinner() {
        const existingSpinner = document.getElementById('search-spinner');
        if (existingSpinner) {
            existingSpinner.remove();
        }
    }

    // Clear search results
    function clearSearchResults() {
        if (searchResultsContainer) {
            searchResultsContainer.innerHTML = '';
            searchResultsContainer.style.display = 'none';
        }
    }

    // Perform AJAX search for WooCommerce products using Store API
    function performSearch(query) {
        const encodedQuery = encodeURIComponent(query.trim());

        const searchUrl = `${window.location.origin}/wp-json/wc/store/products?search=${encodedQuery}&per_page=6&orderby=popularity&stock_status=instock`;

        fetch(searchUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                hideSpinner();
                displaySearchResults(data, query);
            })
            .catch(error => {
                console.error('Error fetching search results:', error);
                hideSpinner();
                showNoResults(query);
            });
    }



    // Display search results
    function displaySearchResults(products, query) {
        if (!searchResultsContainer) return;

        // Don't show "no results" for empty queries
        if (products.length === 0 && query.trim() === '') {
            return;
        }

        if (products.length === 0) {
            showNoResults(query);
            return;
        }

        const resultsHTML = products.map(product => {
            const productImage = product.images && product.images[0] 
                ? product.images[0].src 
                : '/wp-content/themes/nautilus/assets/images/placeholder.jpg';
            
            const productPrice = product.prices && product.prices.price 
                ? `${(product.prices.price / 100).toFixed(2)} zł`
                : 'Cena na żądanie';

            return `
                <li>
                    <a href="${product.permalink}" class="">
                        <div class="flex gap-4 items-center">
                            <img src="${productImage}" alt="${product.name}" class="w-16 max-h-[50px] bg-white p-2 object-cover rounded-xl">
                            <div>
                                <p>${product.name}</p>
                                <div class="flex items-center">
                                    <span class="text-base">${productPrice}</span>
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            `;
        }).join('');

        searchResultsContainer.innerHTML = `
            <div class="gap-4 flex flex-col">
                <ul class="space-y-2">
                    ${resultsHTML}
                </ul>
                <div class="flex justify-center items-center gap-2 mt-4 text-sm text-gray-800 cursor-pointer" onclick="window.location.href='/?s=${encodeURIComponent(query)}'">
                    <p class="flex">
                        Wszystkie wyniki dla "${query}"
                        <svg class="ml-2" width="20px" height="20px" aria-hidden="true">
                            <use href="#chevron-right"></use>
                        </svg>
                    </p>
                </div>
            </div>
        `;

        searchResultsContainer.style.display = 'flex';
    }


    // Show no results message
    function showNoResults(query) {
        if (!searchResultsContainer) return;

        searchResultsContainer.innerHTML = `
            <div class="gap-4 flex flex-col">
                <div class="text-center py-8">
                    <p class="text-gray-600 mb-4">Brak wyników dla "${query}"</p>
                    <p class="text-sm text-gray-500">Spróbuj użyć innych słów kluczowych</p>
                </div>
            </div>
        `;

        searchResultsContainer.style.display = 'flex';
    }
}